import { Close, CloudDownload, HistorySharp, Visibility } from '@mui/icons-material'
import { AppBar, Backdrop, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Stack, TableContainer, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import { DropzoneArea } from 'material-ui-dropzone'
import React, { useEffect, useState } from 'react'
import { PuffLoader } from 'react-spinners'
import { apiAction, ARMLogo, basePdf } from '../../constants/Constant'
import wordIcon from '../../images/WarningImage/docIcon.svg'
import norecord from '../../images/WarningImage/nofiles.svg'
import pdfIcon from '../../images/WarningImage/pdficon.svg'
import { IGetAPIDocument } from '../../models/APITransationLog/IAPITransationLog'
import { useGlobalState } from '../../store/GlobalStore'
import { useDelete, useFetch, usePost } from '../../utils/apiHelper'
import { Transition } from '../GlobalStyles/DialogBoxTransition'
import { DialogTitleHeader } from '../GlobalStyles/DialogStyle'
import useStyles from '../GlobalStyles/DocumentCss'
import LightTooltip from '../GlobalStyles/LightTooltip'
import APIDocumentHistory from './APIDocumentHistory'
import { Snackbar } from '@material-ui/core'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const UploadAPIDocument = () => {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const { state } = useGlobalState();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [progressBar, setshowProgressBar] = useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [fileExists, setFileExists] = useState(false);
    const [documentId, setDocumentId] = useState<number>(0);
    const [serviceURL, setServiceURL] = useState('');
    const [openDocs, setOpenDocs] = useState(false);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [isFileDeleted, setIsFileDeleted] = useState<boolean>(false);
    const [apiDocumentList, setAPIDocumentList] = useState<IGetAPIDocument[]>([]);
    const [documentHistiryId, setDocumentHistoryId] = useState<number>(0);
    const [selectedDocumentHistoryId, setSelectedDocumentHistoryId] = useState<number>(0);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    }

    const handleCloseDocs = () => {
        setOpenDocs(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const handleSubmit = async (selectedFile: File) => {
        if (selectedFile) {
            setshowProgressBar(true);
            (async () => {
                const formData = new FormData();
                formData.append('FileName', selectedFile.name);
                formData.append('FormFile', selectedFile);
                formData.append('UserId', state?.userAccessContext?.id.toString());
                formData.append('ActionId', apiAction.Uploaded.toString());
                await usePost<any>("History/InsertAPIDocumentDetails", formData).finally(() => {
                    handleFetchAPIDocument();
                    //props?.onFetch();
                });
            })().finally(() => {
                setshowProgressBar(false);
            })
        }
    };

    function getPDFFileAsync(blobUri: string, documentID: number) {
        (async () => {
            setshowProgressBar(true);
            await usePost<any>(`File/DownloadFileFromBlob?blobUri=${blobUri}`, null).then((r) => {
                let url = URL.createObjectURL(base64toBlob(basePdf + r?.data));
                setServiceURL(url);
                setOpenDocs((r?.status === 404 || r?.status === 400) ? false : true);
            }).catch(() => {
                setFileExists(true);
            }).finally(() => {
                setshowProgressBar(false);
                InsertAPIDocumentHistory(documentID);
            });
        })();

        const base64toBlob = (data: string) => {
            // Cut the prefix `data:application/pdf;base64` from the raw base 64
            const base64WithoutPrefix = data.substring('data:application/pdf;base64,'.length);
            const bytes = window.atob(base64WithoutPrefix);
            let length = bytes.length;
            let out = new Uint8Array(length);
            while (length--) {
                out[length] = bytes.charCodeAt(length);
            }
            return new Blob([out], { type: 'application/pdf' });
        };
    }

    const FileDeleteAsync = () => {
        setDialogOpen(false);
        setshowProgressBar(true);
        (async () => {
            await useDelete<any>(`History/DeleteAPIDocumentDetails?DocumentId=${documentId}`).finally(() => {
                handleFetchAPIDocument();
            }).finally(() => {
                setshowProgressBar(false);
                setIsFileDeleted(true);
            })
        })()
    }

    const handleFileId = (documentId: number) => {
        setDocumentId(documentId);
        setDialogOpen(true);
    };

    const DownloadFileAsync = (blobUri: string, fileName: string) => {
        setshowProgressBar(true);
        (async () => {
            await usePost<any>(`File/DownloadFileFromBlob?blobUri=${blobUri}`, null).then((r) => {
                const arrayBuffer = base64ToArrayBuffer(r.data);
                createAndDownloadBlobFile(arrayBuffer, fileName);
            }).catch(() => {
                setFileExists(true);
            }).finally(() => {
                setshowProgressBar(false);
            });
        })();
    }

    function base64ToArrayBuffer(base64: string) {
        const binaryString = window.atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
    }

    function createAndDownloadBlobFile(body, filename) {
        const blob = new Blob([body]);
        const fileName = `${filename}`;
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const closeSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setFileExists(false);
        setIsFileDeleted(false);
    };

    // const closeSnackbardDelete = (event?: React.SyntheticEvent, reason?: string) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setUndoUpload(false);
    // };

    const InsertAPIDocumentHistory = (documentID: number) => {
        setshowProgressBar(true);
        (async () => {
            let request = {
                "documentId": documentID,
                "userId": state.userAccessContext.id,
                "actionId": apiAction.Downloaded.toString()
            }
            await usePost<any>("History/InsertAPIDocumentHistory", request).then((r) => {
            }).finally(() => {
                setshowProgressBar(false);
            })
        })()
    }

    useEffect(() => {
        handleFetchAPIDocument();
    }, [])

    const handleFetchAPIDocument = () => {
        setshowProgressBar(true);
        (async () => {
            await useFetch<IGetAPIDocument[]>("History/GetAPIDocumentDetails").then((result) => {
                setAPIDocumentList(result?.data);
            });
        })().finally(() => {
            setshowProgressBar(false);
        });
    }

    return (
        <React.Fragment>
            <Button variant='contained' onClick={handleOpen} size='small' sx={{ mt: '5px' }}>Upload API Document</Button>

            <Dialog
                PaperProps={{ style: { borderRadius: 10 } }}
                fullScreen={fullScreen}
                open={open}
                maxWidth={'xl'}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleClose}>
                    <Typography variant="h5" fontSize={15} color={'white'} gutterBottom mt={"5px"}>
                        Upload API Document
                    </Typography>
                </DialogTitleHeader>
                <DialogContent>
                    <Backdrop className={classes.backdrop} open={progressBar}>
                        <PuffLoader size={80} color={"white"} speedMultiplier={1} />
                    </Backdrop>

                    <Grid container spacing={1} pt={1}>
                        <Grid item xs={12}>
                            <Typography variant='subtitle2' align='justify' className={classes.Note}>
                                <span><b>Note : </b></span>The uploaded document will be saved automatically.
                            </Typography>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid container spacing={0}>
                                <Grid item xs={12}>
                                    <DropzoneArea
                                        onChange={(files) => handleSubmit(files[0])}
                                        acceptedFiles={[
                                            'application/pdf',
                                            'application/msword',
                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                        ]}
                                        showPreviews={false}
                                        showPreviewsInDropzone={false}
                                        filesLimit={1}
                                        dropzoneText="Upload file here or Browse"
                                        dropzoneClass={classes.DropzoneArea}
                                        dropzoneParagraphClass={classes.DropzoneAreaText}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TableContainer className={`${classes.container} ${"scrollbox"} ${"on-scrollbar"}`}>
                                        <Typography variant="h6" fontSize={14} className={classes.UploadStyle} ><b>UPLOADED DOCUMENTS</b></Typography>
                                        <Grid container spacing={0} >
                                            {apiDocumentList?.map((f, index) => {
                                                //let enable = f.fileName.split('.').pop() === 'pdf' ? true : f.fileName.split('.').pop() === 'PDF' ? true : false
                                                const extension = f?.fileName?.split('.').pop()?.toLowerCase();
                                                const isPDF = extension === 'pdf';

                                                return (
                                                    <React.Fragment>
                                                        <Grid container spacing={0} key={index}>
                                                            <Grid item xs={1} className={classes.flexDisplay}>
                                                                <img
                                                                    src={isPDF ? pdfIcon : wordIcon}
                                                                    alt={isPDF ? 'PDF icon' : 'Word icon'}
                                                                    width="20"
                                                                    height="20"
                                                                    style={{ marginTop: '5px' }}
                                                                />

                                                            </Grid>
                                                            <Grid item xs={8.5} >
                                                                <Typography variant="subtitle2" pt={"5px"} className={classes.typoStyle} fontWeight={selectedDocumentHistoryId === f?.documentId ? 600 : 400} color={selectedDocumentHistoryId === f?.documentId ? 'primary' : 'none'}>
                                                                    {f?.fileName}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5} className={classes.flexDisplay}>
                                                                <Stack p={0} flexDirection={'row'} gap={"5px"}>
                                                                    <IconButton size='small' disabled={!isPDF} aria-label="delete" onClick={handleClickOpen} className={classes.Iconbutton}>
                                                                        <LightTooltip title="Preview File">
                                                                            <Visibility onClick={() => { getPDFFileAsync(f?.blobUri, f?.documentId); }} fontSize='small'
                                                                                className={!isPDF ? classes.NonVisible : classes.Visible} />
                                                                        </LightTooltip>
                                                                    </IconButton>

                                                                    <IconButton size='small' aria-label="delete" className={classes.Iconbutton}>
                                                                        <LightTooltip title="Download File">
                                                                            <CloudDownload onClick={() => { DownloadFileAsync(f?.blobUri, f?.fileName); }} className={classes.iconStyle} fontSize='small' />
                                                                        </LightTooltip>
                                                                    </IconButton>

                                                                    <IconButton size='small' aria-label="delete" className={classes.Iconbutton}>
                                                                        <LightTooltip title="View History">
                                                                            <HistorySharp color='secondary'
                                                                                onClick={() => {
                                                                                    setDocumentHistoryId(f?.documentId);
                                                                                    setSelectedDocumentHistoryId(f?.documentId); // track selected
                                                                                }}
                                                                                className={classes.iconStyle} fontSize='small' />
                                                                        </LightTooltip>
                                                                    </IconButton>

                                                                    <IconButton size='small' color="primary" aria-label="upload picture" onClick={() => { handleFileId(f?.documentId); }}
                                                                        className={classes.Iconbutton} >
                                                                        <LightTooltip title="Delete File">
                                                                            <Close style={{ fontSize: 20, color: 'red' }} fontSize='small' />
                                                                        </LightTooltip>
                                                                    </IconButton>
                                                                </Stack>
                                                            </Grid>
                                                        </Grid>

                                                        <Dialog
                                                            PaperProps={{ style: { borderRadius: 15 } }}
                                                            open={isDialogOpen}
                                                            onClose={handleCloseDialog}
                                                            aria-labelledby="alert-dialog-title"
                                                            aria-describedby="alert-dialog-description"
                                                        >
                                                            <DialogTitleHeader id="responsive-dialog-title" onClose={handleCloseDialog}>
                                                                <Typography variant="h6" gutterBottom className={classes.titleheader}>
                                                                    File Delete
                                                                </Typography>
                                                            </DialogTitleHeader>
                                                            <DialogContent >
                                                                <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                                                                    Are you sure, you want to Delete this File?
                                                                </Typography>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button id="NRB_ok_btn" size="small" variant="contained" color="primary" className={classes.yesbutton} onClick={() => { FileDeleteAsync(); }}>
                                                                    Yes
                                                                </Button>
                                                                <Button id="NRB_cancel_btn" size="small" variant='outlined' onClick={handleCloseDialog} className={classes.nobutton} color="error">
                                                                    No
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </Grid>
                                        {!apiDocumentList?.length ?
                                            <Stack p={0} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                                                <div className={classes.noRecordsColor}>
                                                    <img src={norecord} alt="Icon for no document to display" width="60px" height="60px" />
                                                </div>
                                                <Typography variant='h6' fontSize={'14px'} align='center' className={classes.noFiles} pt={"5px"}>
                                                    No API Documents to display..
                                                </Typography>
                                            </Stack>
                                            : null}
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <APIDocumentHistory documentId={documentHistiryId} />
                        </Grid>
                    </Grid>
                </DialogContent >
            </Dialog>

            {openDocs ?
                <Dialog fullScreen className={classes.dialog} open={openDocs} onClose={handleCloseDocs} TransitionComponent={Transition}>
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar className={classes.toolbarStyle}>
                            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" >
                                <img alt="ARM_Solutions" className={classes.menuButton1} src={ARMLogo} />
                            </IconButton>
                            <Typography variant="h6" className={classes.title} >
                                <b>DOCUMENT VIEWER</b>
                            </Typography>
                            <IconButton edge="end" color="inherit" onClick={() => setOpenDocs(false)} aria-label="close" style={{ padding: '5px' }}>
                                <Close style={{ color: '#000', fontSize: 22 }} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Viewer fileUrl={serviceURL}
                            defaultScale={1.50} plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </Dialog> : null
            }

            <Snackbar className="snackbarStyle" open={fileExists} anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={closeSnackbar}>
                <Alert onClose={closeSnackbar} severity="error" className="alertStyle">
                    File does not exists!
                </Alert>
            </Snackbar>

            <Snackbar className="snackbarStyle" open={isFileDeleted} anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={closeSnackbar}>
                <Alert onClose={closeSnackbar} severity="error" className="alertStyle">
                    File Deleted Successfully!
                </Alert>
            </Snackbar>
        </React.Fragment >
    )
}

export default UploadAPIDocument